import * as React from "react";
const CheckAllBig = (props) => (
	<svg
		width={23}
		height={13}
		viewBox="0 0 23 13"
		fill="none"
		xmlns="http://www.w3.org/2000/svg"
		{...props}
	>
		<path
			d="M6 7L10.9497 11.9497L21.5572 1.34326M1.0498 7.05029L5.99955 12M16.606 1.39355L11.3027 6.69686"
			stroke={props.color ? props.color : "white"}
			strokeLinecap="round"
			strokeLinejoin="round"
		/>
	</svg>
);
export default CheckAllBig;